export default __webpack_public_path__ + "static/media/Batman_05.5c719a21.png";